<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div class="flex mb-20px">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        class="w-200px mx-10px"
        v-model="form.name"
        placeholder="请输入实体名称"
        clearable
      ></el-input>
      <el-input
        class="w-200px mr-10px"
        v-model="form.authorization"
        placeholder="请输入授权范围"
        clearable
      ></el-input>
      <el-select
        class="w-200px"
        v-model="form.status"
        placeholder="请选择状态"
        clearable
        filterable
      >
        <el-option
          v-for="(item, index) in approveStatusList"
          :key="index"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button class="ml-10px" type="primary" @click="searchList">搜索</el-button>
      <el-button type="primary" :disabled="!$hasAccess('application')" @click="application"
        >权限申请</el-button
      >
    </div>
    <el-table
      v-loading="tableLoading"
      border
      height="calc(100% - 106px)"
      :data="tableData"
      ref="multipleTable"
    >
      <el-table-column type="index" width="55" label="序号">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + page.pageSize * (page.pageNo - 1) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="className" label="实体名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tableName" label="实体表名"></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="authorizationDimensionRange"
        label="授权范围"
      ></el-table-column>
      <el-table-column show-overflow-tooltip prop="endTime" label="权限有效期至"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createdTime" label="授权时间"></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="approveStatusName"
        label="状态"
      ></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="toDetail(scope.row)">详情</el-button>
          <el-button
            :disabled="!$hasAccess('reclaim') || scope.row.approveStatus !== 1"
            size="mini"
            @click="setValid(scope.row)"
            >权限回收</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px float-right"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="$pageSizeAll"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>
  </el-card>
</template>

<script>
import DataPermissionsService from '@/services/DataPermissionsService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dataPermissions',
  components: {
    selectStandardId,
  },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      form: {
        name: '',
        authorization: '',
        status: null,
      },
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      approveStatusList: [],
    }
  },
  created() {
    this.getApproveStatus()
    this.searchList()
  },
  watch: {
    'form.status': {
      handler(newVal) {
        if (newVal !== null) {
          this.searchList()
        }
      },
    },
  },
  methods: {
    // 切换标准
    updateStandardId(val) {
      this.standardId = val
      this.searchList()
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true
      const res = await DataPermissionsService.query({
        standardId: this.standardId,
        ApproveStatus: this.form.status,
        ClassName: this.form.name,
        AuthorizationRange: this.form.authorization,
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
        Sorting: '',
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.getTableData()
    },
    // 分页
    handleSizeChange(size) {
      this.page.pageSize = size
      this.getTableData()
    },
    // 权限申请
    application() {
      this.$router.push(`./auth-config?standardId=${this.standardId}`)
    },
    // 获取审核状态
    async getApproveStatus() {
      const res = await DataPermissionsService.getApproveStatus()
      if (res) {
        this.approveStatusList = res
      }
    },
    // 权限回收
    async setValid(row) {
      this.$confirm('确定要回收该权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await DataPermissionsService.setValid({
            authorizationClassId: row.authorizationClassId,
            authorizationDimensionClassRelationId: row.id,
          })
          if (!res.message) {
            this.$message.success('权限回收成功')
            this.getTableData()
          }
        })
        .catch()
    },
    // 跳转详情
    toDetail(row) {
      this.$router.push({
        path: './data-permissions-detail',
        query: {
          classId: row.classId,
          authorizationClassId: row.authorizationClassId,
          approveStatusName: row.approveStatusName,
          authorizationDimensionId: row.authorizationDimensionId,
          // isaudit: true,
        },
      })
    },
  },
}
</script>
